import { Injectable } from '@angular/core';
import { ProfileInterface } from '../profile-interface';
import {CourseCatalogueService } from './course-catalogue.service';
import { HttpClient } from '@angular/common/http';
import {Observable } from 'rxjs/Observable';
interface isLoggedIn{
  status : boolean
}
@Injectable()
export class ProfileService {
  public x;
  public courses;
  public history;
  public depts;
  public cour;
  public levels;
  public studentLevel;
  public studentDept;
  public presentSemester;
  public chosenSemester;
  public ff = [];
  public reg_courses;
  public courseLength;
  public allCourses;
  public taxi;
  public extra;
  public extraCourse;
  public total;
  public mark;
  public tcp;
  public attained;
  public tattained;
  public gradee;
  public q;
  public cumUnit = 0;
  public cumTotal = 0;
  public cumTotalAttainable = 0;
  public details = [2,1,1];
  public lname;
  public mname;
  public dob;
  public phone1;
  public phone2;
  public email;
  public address;
  public studentDetails;
  //change student dept, level, semester in order
  /*
    1 => first semester;
    2 => second semester;
    using level index as id;
  */
 public loggedInStudent = 5;
  constructor(private _CourseCatalogueService : CourseCatalogueService, private http : HttpClient) { }
  getStudentDetails(){
    this.x = [
      {
      student_id:1,lname:"Oyelayo",fname:"Toyosi",mname:"Timilehin",dob:"2/2/2",
      nationality:"Nigerian",origin:"Oyo",mstatus:"Complicated",Phone1:"07066898530",phone2:"0808",
  email:"toyosioyelayo@gmail.com",address:"P24, Royal Valley Estate, Ilorin",next_of_kin_name:"Fred Jong",
      kin_phone:"890980",kin_email:"jong@gmail.com",cgpa:"4.90",passport:"assets/images/admin2.png",gender:"M"
    },
    {
      student_id:2,lname:"Ademola",fname:"Samuel",mname:"Sule",dob:"2/2/2",
      nationality:"Nigerian",origin:"Oyo",mstatus:"Complicated",Phone1:"07066898530",phone2:"0808",
  email:"toyosioyelayo@gmail.com",address:"P24, Royal Valley Estate, Ilorin",next_of_kin_name:"Fred Jong",
      kin_phone:"890980",kin_email:"jong@gmail.com",cgpa:"4.90",passport:"assets/images/boy.png",gender:"M"
    },
    {
      student_id:3,lname:"Olawepo",fname:"Glory",mname:"Babatunde",dob:"2/2/2",
      nationality:"Nigerian",origin:"Oyo",mstatus:"Complicated",Phone1:"07066898530",phone2:"0808",
  email:"toyosioyelayo@gmail.com",address:"Suleja",next_of_kin_name:"Fred Jong",
      kin_phone:"890980",kin_email:"jong@gmail.com",cgpa:"4.90",passport:"assets/images/counsellor.png",gender:"M"
    },
    {
      student_id:4,lname:"Adesoye",fname:"Jeremiah",mname:"Musbau",dob:"2/2/2",
      nationality:"Nigerian",origin:"Oyo",mstatus:"Complicated",Phone1:"07066898530",phone2:"0808",
  email:"toyosioyelayo@gmail.com",address:"P24, Royal Valley Estate, Ilorin",next_of_kin_name:"Fred Jong",
      kin_phone:"890980",kin_email:"jong@gmail.com",cgpa:"4.90",passport:"assets/images/admin2.png",gender:"M"
    },
    {
      student_id:5,lname:"Bello",fname:"Tafa",mname:"Musbau",dob:"2/2/2",
      nationality:"Nigerian",origin:"Oyo",mstatus:"Complicated",Phone1:"07066898530",phone2:"0808",
  email:"btafa@gmail.com",address:"P24, Royal Valley Estate, Ilorin",next_of_kin_name:"Fred Jong",
      kin_phone:"890980",kin_email:"jong@gmail.com",cgpa:"4.88",passport:"assets/images/counsellor.png",gender:"M"
    }
  ];
  for(let i = 0; i < this.x.length; i++){
    if(this.x[i].student_id == this.loggedInStudent){
      return this.x[i];
    }
  }
    
  }
  getCourseDetails2(){

  }
  getCourseDetails(){
    this.courses = [
      {
        "level":"100",
        "semester":"first",
          "tab":
            [
              {"course_code":"CSE 103", "course_title":"Into to computing", "grade":"A","units":4, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
              {"course_code":"CSE 109", "course_title":"Python Programming", "grade":"A","units":3, "marks":65,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
              {"course_code":"CSE 131", "course_title":"Artificial Intelligence", "grade":"A","units":4, "marks":78,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
              {"course_code":"CSE 171", "course_title":"Algebra", "grade":"A","units":4, "marks":80,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
              {"course_code":"CSE 199", "course_title":"Into to computing", "grade":"A","units":2, "marks":47,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
              {"course_code":"CSE 186", "course_title":"Into to computing", "grade":"A","units":2, "marks":53,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},

            ],
          
    },
  
    {
      "level":"100",
      "semester":"second",
        "tab":
          [
            {"course_code":"CSE 102", "course_title":"Into to computing", "grade":"A","units":5, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
            {"course_code":"CSE 109", "course_title":"Python Programming", "grade":"A","units":4, "marks":77,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
            {"course_code":"CSE 131", "course_title":"Artificial Intelligence", "grade":"A","units":4, "marks":75,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
            {"course_code":"CSE 171", "course_title":"Algebra", "grade":"A","units":3, "marks":80,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
            {"course_code":"CSE 199", "course_title":"Into to computing", "grade":"A","units":1, "marks":70,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
            {"course_code":"CSE 199", "course_title":"Into to computing", "grade":"A","units":1, "marks":65,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
            {"course_code":"CSE 199", "course_title":"Into to computing", "grade":"A","units":1, "marks":65,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
            {"course_code":"CSE 199", "course_title":"Into to computing", "grade":"A","units":2, "marks":65,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
            {"course_code":"CSE 199", "course_title":"Into to computing", "grade":"A","units":2, "marks":65,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
            {"course_code":"CSE 199", "course_title":"Into to computing", "grade":"A","units":0, "marks":70,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},


          ]
  },
  
  {
    "level":"200",
    "semester":"first",
      "tab":
        [
          {"course_code":"CSE 102", "course_title":"Into to computing", "grade":"A","units":4, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 109", "course_title":"Python Programming", "grade":"A","units":5, "marks":12,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 131", "course_title":"Artificial Intelligence", "grade":"A","units":3, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 171", "course_title":"Algebra", "grade":"A","units":3, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 199", "course_title":"Into to computing", "grade":"A","units":4, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
        ]
  },
  
  {
    "level":"200",
    "semester":"second",
      "tab":
        [
          {"course_code":"CSE 104", "course_title":"Into to computing", "grade":"A","units":4, "marks":20,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 109", "course_title":"Python Programming", "grade":"A","units":4, "marks":77,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 131", "course_title":"Artificial Intelligence", "grade":"A","units":4, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 171", "course_title":"Algebra", "grade":"A","units":4, "marks":12,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 199", "course_title":"Into to computing", "grade":"A","units":4, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
        ]
  },
  
  {
    "level":"300",
    "semester":"first",
      "tab":
        [
          {"course_code":"CSE 102", "course_title":"Into to computing", "grade":"A","units":4, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 109", "course_title":"Python Programming", "grade":"A","units":4, "marks":77,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 131", "course_title":"Artificial Intelligence", "grade":"A","units":4, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 171", "course_title":"Algebra", "grade":"A","units":4, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 199", "course_title":"Into to computing", "grade":"A","units":4, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
        ]
  },
  
  {
    "level":"300",
    "semester":"second",
      "tab":
        [
          {"course_code":"CSE 102", "course_title":"Into to computing", "grade":"A","units":4, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 109", "course_title":"Python Programming", "grade":"A","units":1, "marks":77,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 131", "course_title":"Artificial Intelligence", "grade":"A","units":4, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 171", "course_title":"Algebra", "grade":"A","units":4, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 199", "course_title":"Into to computing", "grade":"A","units":3, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
        ]
  },
  
  {
    "level":"400",
    "semester":"first",
      "tab":
        [
          {"course_code":"CSE 102", "course_title":"Into to computing", "grade":"A","units":2, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 109", "course_title":"Python Programming", "grade":"A","units":4, "marks":77,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 131", "course_title":"Artificial Intelligence", "grade":"A","units":4, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 171", "course_title":"Algebra", "grade":"A","units":4, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 199", "course_title":"Into to computing", "grade":"A","units":4, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
        ]
  },
  
  
  {
    "level":"400",
    "semester":"second",
      "tab":
        [
          {"course_code":"CSE 102", "course_title":"Into to computing", "grade":"A","units":4, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 109", "course_title":"Python Programming", "grade":"A","units":4, "marks":77,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 131", "course_title":"Artificial Intelligence", "grade":"A","units":4, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 171", "course_title":"Algebra", "grade":"A","units":4, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 199", "course_title":"Into to computing", "grade":"A","units":4, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
        ]
  },
  
  {
    "level":"500",
    "semester":"first",
      "tab":
        [
          {"course_code":"CSE 102", "course_title":"Into to computing", "grade":"A","units":4, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 109", "course_title":"Python Programming", "grade":"A","units":4, "marks":77,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 131", "course_title":"Artificial Intelligence", "grade":"A","units":4, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 171", "course_title":"Algebra", "grade":"A","units":4, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 199", "course_title":"Into to computing", "grade":"A","units":4, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
        ]
  },
  
  {
    "level":"500",
    "semester":"second",
      "tab":
        [
          {"course_code":"CSE 102", "course_title":"Into to computing", "grade":"A","units":4, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 109", "course_title":"Python Programming", "grade":"A","units":4, "marks":77,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 131", "course_title":"Artificial Intelligence", "grade":"A","units":4, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 171", "course_title":"Algebra", "grade":"A","units":4, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
          {"course_code":"CSE 199", "course_title":"Into to computing", "grade":"A","units":4, "marks":72,"gp":4.3,"tgp":10,"reg_date":"2018-05-22"},
        ]
  },
    
    
          
    ];
    for(let x in this.courses){
      this.total = 0;
      this.q = 0;
      let dd = this.courses[x].tab;
      for(let y in dd){
        if(dd[y].marks <= 100 && dd[y].marks >= 70){
          this.gradee = 5;
        }else if(dd[y].marks <= 69 && dd[y].marks >= 60){
          this.gradee = 4;
        }else if(dd[y].marks <= 59 && dd[y].marks >= 50){
          this.gradee = 3;
        }else if(dd[y].marks <= 49 && dd[y].marks >= 45){
          this.gradee = 2;
        }else if(dd[y].marks <= 44 && dd[y].marks >= 40){
          this.gradee = 1;
        }else if(dd[y].marks <= 39 && dd[y].marks >= 0){
          this.gradee = 0;
        }
        this.mark = dd[y].units;
        this.tattained = dd[y].units * this.gradee;
        this.total += this.mark;
        this.q += this.tattained;
        this.cumUnit += dd[y].units;
        this.cumTotal += this.mark;
        this.cumTotalAttainable += this.tattained;
      }
      this.courses[x].tot = this.total;
      this.courses[x].attainedGrade = this.q;

      this.courses[x].cummulativeUnits = this.cumUnit;
      this.courses[x].cummulativeTotal = this.cumTotal;
      this.courses[x].cummulativeTotalAttainable = this.cumTotalAttainable
     
    }
    return this.courses;

  }

  getRegHistory(){
    this.history = [
      {
        "level":"100",
        "semester":"first",
          "tab":
            [
              {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
              {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
              {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
              {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
              {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"}
            ]
    },
  
    {
      "level":"100",
      "semester":"second",
        "tab":
        [
          {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
          {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
          {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
          {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
          {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"}
        ]
  },
  
  {
    "level":"200",
    "semester":"first",
      "tab":
      [
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"}
      ]
  },
  
  {
    "level":"200",
    "semester":"second",
      "tab":
      [
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"}
      ]
  },
  
  {
    "level":"300",
    "semester":"first",
      "tab":
      [
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"}
      ]
  },
  
  {
    "level":"300",
    "semester":"second",
      "tab":
      [
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"}
      ]
  },
  
  {
    "level":"400",
    "semester":"first",
      "tab":
      [
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"}
      ]
  },
  
  
  {
    "level":"400",
    "semester":"second",
      "tab":
      [
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"}
      ]
  },
  
  {
    "level":"500",
    "semester":"first",
      "tab":
      [
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"}
      ]
  },
  
  {
    "level":"500",
    "semester":"second",
      "tab":
      [
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"},
        {"date":"02-02-2018","pDetails":"Tuition","amount":"100000"}
      ]
  },
    
    
          
    ]
    return this.history;

  }
  public courr = [
    //100l cse courses
    {"course_id":1,"abbr":"CSE101","name":"Intro to computing","dept_id":1,"level_id":0,"semester_id":1,"units":3},
    {"course_id":2,"abbr":"CSE111","name":"Intro to Java","dept_id":1,"level_id":0,"semester_id":1,"units":3},
    {"course_id":3,"abbr":"CSE102","name":"Intro to computing2","dept_id":1,"level_id":0,"semester_id":2,"units":3},
    {"course_id":4,"abbr":"CSE112","name":"Intro to computing3","dept_id":1,"level_id":0,"semester_id":2,"units":3},
    

    //200l cse courses
    {"course_id":17,"abbr":"CSE201","name":"Intro to computing","dept_id":1,"level_id":1,"semester_id":1,"units":3},
    {"course_id":18,"abbr":"CSE202","name":"Intro to Java","dept_id":1,"level_id":1,"semester_id":1,"units":0},
    {"course_id":19,"abbr":"CSE231","name":"Intro to computing2","dept_id":1,"level_id":1,"semester_id":2,"units":5},
    {"course_id":20,"abbr":"CSE221","name":"Intro to computing3","dept_id":1,"level_id":1,"semester_id":2,"units":3},
    {"course_id":21,"abbr":"CSE201","name":"Intro to computing","dept_id":1,"level_id":1,"semester_id":1,"units":2},
    {"course_id":22,"abbr":"CSE202","name":"Intro to Java","dept_id":1,"level_id":1,"semester_id":1,"units":3},
    {"course_id":23,"abbr":"CSE231","name":"Intro to computing2","dept_id":1,"level_id":1,"semester_id":2,"units":1},
    {"course_id":24,"abbr":"CSE221","name":"Intro to computing3","dept_id":1,"level_id":1,"semester_id":2,"units":3},
    {"course_id":25,"abbr":"CSE201","name":"Intro to computing","dept_id":1,"level_id":1,"semester_id":1,"units":3},
    {"course_id":26,"abbr":"CSE202","name":"Intro to Java","dept_id":1,"level_id":1,"semester_id":1,"units":3},
    {"course_id":27,"abbr":"CSE231","name":"Intro to computing2","dept_id":1,"level_id":1,"semester_id":2,"units":3},
    {"course_id":28,"abbr":"CSE221","name":"Intro to computing3","dept_id":1,"level_id":1,"semester_id":2,"units":2},
    {"course_id":29,"abbr":"CSE201","name":"Intro to computing","dept_id":1,"level_id":1,"semester_id":1,"units":1},
    {"course_id":30,"abbr":"CSE202","name":"Intro to Java","dept_id":1,"level_id":1,"semester_id":1,"units":3},
    {"course_id":31,"abbr":"CSE231","name":"Intro to computing2","dept_id":1,"level_id":1,"semester_id":2,"units":4},
    {"course_id":32,"abbr":"CSE221","name":"Intro to computing3","dept_id":1,"level_id":1,"semester_id":2,"units":3},
    {"course_id":33,"abbr":"CSE201","name":"Intro to computing","dept_id":1,"level_id":1,"semester_id":1,"units":3},
    {"course_id":34,"abbr":"CSE202","name":"Intro to Java","dept_id":1,"level_id":1,"semester_id":1,"units":3},
    {"course_id":35,"abbr":"CSE231","name":"Intro to computing2","dept_id":1,"level_id":1,"semester_id":2,"units":2},
    {"course_id":36,"abbr":"CSE221","name":"Intro to computing3","dept_id":1,"level_id":1,"semester_id":2,"units":3},

    //100 mee courses
    {"course_id":9,"abbr":"MEE101","name":"Intro to machines","dept_id":2,"level_id":0,"semester_id":1,"units":3},
    {"course_id":10,"abbr":"MEE111","name":"Intro to Java","dept_id":2,"level_id":0,"semester_id":1,"units":3},
    {"course_id":11,"abbr":"MEE102","name":"Intro to computing2","dept_id":2,"level_id":0,"semester_id":2,"units":3},
    {"course_id":12,"abbr":"MEE112","name":"Intro to computing3","dept_id":2,"level_id":0,"semester_id":2,"units":3},

    //200l mee courses
    {"course_id":37,"abbr":"MEE200","name":"Intro to computing","dept_id":2,"level_id":1,"semester_id":1,"units":2},
    {"course_id":38,"abbr":"MEE211","name":"Intro to Java","dept_id":2,"level_id":1,"semester_id":1,"units":4},
    {"course_id":39,"abbr":"MEE202","name":"Intro to computing2","dept_id":2,"level_id":1,"semester_id":2,"units":1},
    {"course_id":40,"abbr":"CSE245","name":"Intro to computing3","dept_id":2,"level_id":1,"semester_id":2,"units":2},
    {"course_id":41,"abbr":"MEE243","name":"Intro to computing","dept_id":2,"level_id":1,"semester_id":1,"units":3},
    {"course_id":42,"abbr":"MEE212","name":"Intro to Java","dept_id":2,"level_id":1,"semester_id":1,"units":5},
    {"course_id":43,"abbr":"MEE222","name":"Intro to computing2","dept_id":2,"level_id":1,"semester_id":1,"units":3},
    {"course_id":44,"abbr":"CSE228","name":"Intro to computing3","dept_id":2,"level_id":1,"semester_id":1,"units":3},

   
  ];


  getAllCourses(){
    this.allCourses = [];
    for(var q in this.courr){
      this.taxi = [];
      this.taxi.push(this.courr[q].course_id,this.courr[q].abbr,this.courr[q].units,this.courr[q].name);
      this.allCourses.push(this.taxi);
    }
    return this.allCourses;
  }
  selectedSemester(x){
    this.chosenSemester = x;
    this.courseLength = this.ff.length;
    this.getCourse(this.chosenSemester, this.courseLength);
  }
 
  pushCourses(x){
    this.reg_courses = x;
    return this.reg_courses;
  }
 

  getDept(){
    this.depts = [
      {"dept_id":1,"abbr":"CSE","name":"Computer Science and Engineering"},
      {"dept_id":2,"abbr":"MEE","name":"Mechanical Engineering"},
      {"dept_id":3,"abbr":"EEE","name":"Electrical and Electronics Engineering"},
      {"dept_id":4,"abbr":"AGE","name":"Agric Engineering"}
    ]
    return this.depts[this.details[0]];
  }
  getLevel(){
    this.levels = ["100","200","300","400","500"];
    return this.levels[this.details[1]];
  }
  getCourse(x,y){
   
    
   // this.ff = [];
   this.ff.splice(0,y);
    for(let course of this.courr){
      if(course.dept_id == this.details[0] &&
         course.level_id == this.details[1] && course.semester_id == x){
          this.ff.push(course);
          //return course.abbr;
      }
      
    }
    return this.ff;

    
  }
  getSemester(){
    this.presentSemester = ['R','H'];
    return this.presentSemester[this.details[2]];
  }


 semesterResult(){
   return [4.8,4.9,4.5,5.0,4.6];
 }
 getTCP(){
  return this.getCourseDetails();
 }


 studDetails(x:object){
  this.studentDetails = x;
 }

 get StudentDetails(){
   return this.studentDetails;
 }

 updateDetails(usr){ 
  let x = window.location.protocol + '//' + window.location.host;
  let port = window.location.port;
  let y = x.replace(":"+port,"");
    return this.http.post<any>("/edozzier/updateStudentDetails.php",usr);
 }

  // isLoggedIn(): Observable<isLoggedIn>{
  //   let x = window.location.protocol + '//' + window.location.host;
  //   let port = window.location.port;
  //   let y = x.replace(":"+port,"");
  //   if(y.indexOf('localhost') > -1){
  //     return this.http.get<isLoggedIn>("http://localhost/api/isLoggedIn.php");
  //   }else{
  //     return this.http.get<isLoggedIn>("/api/isLoggedIn.php");
  //   }
   
  // }

}
